import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useCurrentUser } from '@/hooks';

import LoadingCover from '@/components/Layouts/Loading';
import { isCoach } from '@/types/user';

const Root = () => {
  const { user, isUserLoading } = useCurrentUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (isUserLoading) return;

    if (isCoach(user)) navigate('/coach', { replace: true });
    else navigate('/m', { replace: true });
  }, [user.id, isUserLoading, navigate, user]);

  return <LoadingCover />;
};

export default Root;
